import { Breadcrumbs } from "components/breadcrumbs";
import { useOne, useParse } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import EditFipixForm from "./components/editAccount";
import { IFipixAccountDetail } from "interfaces";

export const EditFipixAccount: React.FC = () => {
  const parse = useParse();
  const { params } = parse();

  const { data, isFetching, isPreviousData, isLoading } =
    useOne<IFipixAccountDetail>({
      resource: "fipix/accounts",
      id: params?.id,
      meta: {
        resource: "data",
      },
      queryOptions: {
        enabled: !!params?.id,
      } as any,
    });

  const fipixAccountDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Fipix Account" />
      {fipixAccountDetailData ? (
        <EditFipixForm
          defaultAccountData={fipixAccountDetailData}
          id={params?.id}
        />
      ) : (
        <></>
      )}
      {isFetching && isPreviousData ? <FullScreenLoading /> : <></>}
    </div>
  );
};
